"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _orderDisplay = _interopRequireDefault(require("./order-display"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render Message Component
 *
 * @class Message
 * @public
 *
 * @returns {React.ReactElement}
 */

class Message extends _react.Component {
  render() {
    const {
      email,
      contactOptOut,
      contactPreferences,
      order,
      orderTotal,
      orderTotalPrefix,
      receiptUrl,
      preferenceUrl,
      printReceipt
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, email && /*#__PURE__*/_react.default.createElement("p", {
      className: "order-font-base"
    }, email), preferenceUrl && contactPreferences && contactOptOut && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, contactOptOut), /*#__PURE__*/_react.default.createElement("a", {
      href: preferenceUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "order-link-style contact-preferences"
    }, contactPreferences))), order && /*#__PURE__*/_react.default.createElement(_orderDisplay.default, order), orderTotal && orderTotalPrefix && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "order-font-base"
    }, orderTotalPrefix, " ", /*#__PURE__*/_react.default.createElement("strong", null, orderTotal))), receiptUrl && printReceipt && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "uxicon uxicon-page"
    }), /*#__PURE__*/_react.default.createElement("a", {
      href: receiptUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "order-link-style receipt"
    }, printReceipt))));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

Message.propTypes = {
  /** Ordering customers email */
  email: _propTypes.default.string,
  /** Opt out message before preferenceURL */
  contactOptOut: _propTypes.default.string,
  /** Anchor text for preference URL */
  contactPreferences: _propTypes.default.string,
  /** Order data */
  order: _propTypes.default.object,
  /** Entire order total */
  orderTotal: _propTypes.default.string,
  /** Phrase identifying order total (Ex: 'Here is the order total') */
  orderTotalPrefix: _propTypes.default.string,
  /** URL for altering preference data */
  preferenceUrl: _propTypes.default.string,
  /** Link to print receipt */
  printReceipt: _propTypes.default.string,
  /** Link for getting receipt */
  receiptUrl: _propTypes.default.string
};
var _default = Message;
exports.default = _default;